var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.isMask)?_c('div',{staticClass:"mask",on:{"click":_vm.closeDialog}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }